import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { settingsAPI as API } from "../../apis/settings";
import { RootState } from "../store";

export const loadSettings = createAsyncThunk(
  "loadSettings",
  () => API.fetch(),
  {
    condition: (_, { getState }: any) => {
      const { settings } = getState() as RootState;
      if (settings.data) return false;
    },
  }
);

type SettingsState = {
  status: "idle" | "loading" | "succeeded" | "failed";
  data?: Settings;
};
const initialState: SettingsState = {
  status: "idle"
};

const slice = createSlice({
  name: "settings",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(loadSettings.pending, (state) => {
        state.status = "loading";
      })
      .addCase(loadSettings.rejected, (state) => {
        state.status = "failed";
      })
      .addCase(loadSettings.fulfilled, (state, { payload }) => {
        state.status = "succeeded";
        state.data = payload.data
      });
  },
});

export default slice.reducer;
